import { Session__EndDate } from "./Session__EndDate";
import { UTCDate__IsAfter } from "./UTCDate__IsAfter";

export function Session__IsUpcoming(session) {
  const endDateTime = Session__EndDate(session);
  return UTCDate__IsAfter(endDateTime, undefined);
}
